function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import { computed, defineComponent, ref, watch, h } from '@vue/composition-api';
import { withInstall } from '../util';
import { createNamespace } from '../util/create';
import { linear, animationGenerator, transitionFunctionMap } from './animation-func';

var _createNamespace = createNamespace('transition'),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

export var transitionProps = {
  value: {
    type: Number,
    "default": 0
  },
  duration: {
    type: Number,
    "default": 500
  },
  delay: {
    type: Number,
    "default": 0
  },
  timingFunction: {
    type: String,
    "default": 'linear'
  },
  customFunction: {
    type: Function,
    required: false
  },
  easyFunction: {
    type: Function,
    required: false
  }
};
var Animation = defineComponent({
  name: name,
  props: transitionProps,
  slots: ['default'],
  emits: ['change', 'transition-start', 'transition-end'],
  setup: function setup(props, _ref) {
    var slots = _ref.slots,
        root = _ref.root,
        emit = _ref.emit;

    if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function (fn) {
        return setTimeout(fn, 17);
      };
    }

    var realValue = ref(props.value);
    var finalDistance = 0;
    var currentTime = 0;
    var startDistance = 0;

    var sleep = function sleep(ms) {
      return new Promise(function (resolve) {
        return ms === 0 ? resolve('') : setTimeout(resolve, ms);
      });
    };

    var realFunction = computed(function () {
      if (typeof props.easyFunction === 'function' && props.easyFunction.length === 1) {
        return animationGenerator(props.easyFunction);
      }

      if (typeof props.customFunction === 'function') {
        if (props.customFunction.length === 4) {
          return props.customFunction;
        }
      }

      return transitionFunctionMap[props.timingFunction] || linear;
    });

    var handleTransitionStart = function handleTransitionStart() {
      currentTime = new Date().getTime();
      emit('transition-start');
    };

    var isAnimating = false;

    var handleTransitionEnd = function handleTransitionEnd() {
      isAnimating = false;
      emit('transition-end');
    };

    var handleChange = function handleChange(newVal, oldVal) {
      finalDistance = newVal;
      startDistance = realValue.value;
      sleep(props.delay).then(function () {
        handleTransitionStart();

        if (!isAnimating) {
          doAnimate();
        }
      });
    };

    var doAnimate = function doAnimate() {
      if (props.duration === 0) {
        realValue.value = props.value;
        handleTransitionEnd();
        return;
      }

      isAnimating = true;
      var nowTime = new Date().getTime();
      var t = nowTime - currentTime;

      if (t > props.duration) {
        t = props.duration;
      }

      var change = finalDistance - startDistance;
      realValue.value = realFunction.value(t, startDistance, change, props.duration);
      emit('change', realValue.value);

      if (t < props.duration) {
        window.requestAnimationFrame(doAnimate);
      } else {
        setTimeout(function () {
          handleTransitionEnd();
        });
      }
    };

    watch(function () {
      return props.value;
    }, function (newVal, oldVal) {
      handleChange(newVal, oldVal);
    });
    return function () {
      var _slots$default;

      return h("div", {
        "class": "m-animation"
      }, [(_slots$default = slots["default"]) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots, realValue)]);
    };
  }
});
withInstall(Animation);
export default Animation;